import Model from './BaseModel';
import SportEvent from '@/Models/SportEvent.js';

export default class SportcastSelection extends Model {
	resourceName() {
		return 'sportcast_selections';
	}

	fields() {
		return [
			'name',
			'remote_selections',
			'remote_selection_ids',
			'win_count',
			'status',
			'bet_count',
			'liabilities',
			'resulted_at'
		];
	}

	relationships() {
		return {
			sport_event: new SportEvent()
		};
	}

	manualResult(data) {
		return this.makePersistRequest({
			url: `${this.selfUrl()}/results`,
			method: 'PATCH',
			data
		});
	}

	unresult() {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sportcast_selections/${this.id}/unfinalise`,
			method: 'POST'
		});
	}

	adjustLiabilityLimit(newSelectionLimit, newMultiSelectionLimit) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/liability_settings`,
			method: 'POST',
			data: {
				selection_limit: newSelectionLimit,
				multi_selections_limit: newMultiSelectionLimit
			}
		});
	}
}
